@if (display()) {
  <div class="policy-container">
    <mat-card appearance="outlined" class="">
      <mat-card-content>
        <h1>{{ 'PRIVACY_POLICY.POLICY' | translate }}</h1>
        <span>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
          ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
          ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
          sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id
          est laborum.
        </span>
        <div class="privacy-files">
          @for (file of privacyFiles; track file) {
            <div
              class="privacy-file"
              (click)="download(file)"
              (keydown.enter)="download(file)"
              (keydown.space)="download(file)"
              tabindex="0"
            >
              <mat-icon>description</mat-icon>
              <span>{{ file.name }}</span>
            </div>
          }
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}

<!--<app-loading-circle *ngIf="!display()"></app-loading-circle>-->
<app-loading-circle [display]="!display()"></app-loading-circle>
